import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestCardTypeList = () => {
  const getUrl = '/user/card_type';

  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestCompanyCardTypeList = () => {
  const result = apiClient.get(
    '/user/company_card_type',
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestCardTypeList,
  requestCompanyCardTypeList,
};
